module.exports = __webpack_public_path__ + "static/media/AMEX.eb25866a.png";